// https://raw.githubusercontent.com/michaelficarra/bigint-serialiser/refs/heads/master/index.js

// Set constants for VLQ encoding
const SIGNIFICANT_BITS = 7n
const CONTINUE = 1n << SIGNIFICANT_BITS // 128n
const REST_MASK = CONTINUE - 1n // 127n

export function BigIntToUint8(value: bigint): Uint8Array {
  // Handle value sign - encode negative values using ZigZag encoding
  if (value < 0n) {
    value = -value
    --value
    value <<= 1n
    value |= 1n
  } else {
    value <<= 1n
  }

  // Calculate required length
  let length = 1
  let temp = value
  while (temp >= CONTINUE) {
    temp >>= SIGNIFICANT_BITS
    --temp
    ++length
  }

  // Create array and fill it
  const bytes = new Uint8Array(length)
  let offset = 0

  while (value >= CONTINUE && offset < bytes.length) {
    bytes[offset] = Number((value & REST_MASK) | CONTINUE)
    value >>= SIGNIFICANT_BITS
    --value
    ++offset
  }

  bytes[offset] = Number(value)

  return bytes
}
